var map = {
	"./bomba_zmag.jpg": "e830",
	"./bomba_zmix.jpg": "40a6",
	"./bomba_zprop.jpg": "4be7",
	"./manutencao_image.jpg": "fa89",
	"./service_zecon 3.png": "6ac0",
	"./service_zecon.png": "ac2d",
	"./valvula_borboleta.jpg": "504b",
	"./valvula_vc38.jpg": "49ec",
	"./valvula_vg37.jpg": "6f7f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "889f";